import { create } from "zustand";
import { persist } from "zustand/middleware";

export interface AuthUser {
  id: string;
  email: string;
  full_name: string;
  role: "student" | "teacher" | "institution_admin" | "platform_admin";
}

interface AuthState {
  accessToken: string | null;
  refreshToken: string | null;
  user: AuthUser | null;
  setSession: (tokens: { accessToken: string; refreshToken: string }) => void;
  setUser: (user: AuthUser) => void;
  logout: () => void;
}

export const useAuthStore = create<AuthState>()(
  persist(
    (set) => ({
      accessToken: null,
      refreshToken: null,
      user: null,
      setSession: ({ accessToken, refreshToken }) =>
        set({ accessToken, refreshToken }),
      setUser: (user) => set({ user }),
      logout: () => {
        // Logout cross-módulo: además del estado del shell, limpiar el SSO del
        // módulo triage (mismas claves de localStorage, mismo origen) para no
        // dejar una sesión viva en /triage tras cerrar sesión en el hospital.
        try {
          localStorage.removeItem("cgt_token");
          localStorage.removeItem("cgt_user");
        } catch {
          /* localStorage no disponible */
        }
        set({ accessToken: null, refreshToken: null, user: null });
      },
    }),
    {
      name: "simumed.auth",
      partialize: (s) => ({
        accessToken: s.accessToken,
        refreshToken: s.refreshToken,
        user: s.user,
      }),
    },
  ),
);

export function isAuthenticated(): boolean {
  return Boolean(useAuthStore.getState().accessToken);
}
